import React from 'react';
import at from 'lodash/at';
import { useField } from 'formik';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { makeStyles } from '@mui/styles';
import { Trans } from 'react-i18next'
import dataStorage from 'dataStorage';

const useStyles = makeStyles((theme) => {
  return ({
    formControl: {
      margin: '8px 0 !important',
      '& .MuiFormControlLabel-root': {
        alignItems: 'flex-start',
        '& > span': {
          '&:first-child': {
            height: 'fit-content',
            paddingTop: 0,
            paddingBottom: 0
          }
        }
      }
    }
  })
});

export default function CheckboxField(props) {
  const classes = useStyles();
  const { label, helpText, condition, translate = true, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const [touched, error] = at(meta, 'touched', 'error');
  const { setValue } = helper;
  const isError = touched && error && true;

  function _renderHelperText() {
    if (touched && error) {
      return <FormHelperText><Trans values={{ label: dataStorage.translate(label) }}>{error}</Trans></FormHelperText>;
    } else if (helpText && condition?.(field.value)) {
      return <FormHelperText><Trans>{helpText}</Trans></FormHelperText>;
    }
  }

  function _onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <FormControl className={classes.formControl} {...rest} error={isError}>
      <FormControlLabel
        value={field.value}
        checked={!!field.value}
        control={<Checkbox {...field} onChange={_onChange} />}
        label={translate ? <Trans>{label}</Trans> : label}
      />
      {_renderHelperText()}
    </FormControl>
  );
}
